import DefaultDialogParser from "../../../../../../shared/lib/html5-software-library/src/ranj/eng/dialog/framework/serialization/DefaultDialogParser";
import LanguagePack from "../../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";

/**
* DialogFactory.js
* 
* Created on 3-okt-2013, 15:27:50
*
* @author Ivo Swartjes for Ranj
**/
export default class DialogFactory {
    constructor(assetLibrary, languagePack) {
        this.assetLibrary = assetLibrary;
        this.languagePack = languagePack;

        this.dialogCache = {};
        this.dialogParser = new DefaultDialogParser(this.languagePack);
    }

    getDialog(dialogID) {
        let dialog = this.dialogCache[dialogID];
        if (dialog) return dialog;

        const jsonStr = this.assetLibrary.getAsset(dialogID);
        if (!jsonStr) return null;

        let jsonObj;
        if (typeof jsonStr === 'string') {
            jsonObj = JSON.parse(jsonStr);
        } else {
            // Already parsed by PreloadJS
            jsonObj = jsonStr;
        }

        // Support loading .sty file directly
        if (!!jsonObj.dialog) {
            // NB: if no language pack is available in the Asset Library, then use Dialog file's language pack
            if (!this.assetLibrary.hasAsset(`${dialogID}.lp`)) {
                var nwLanguagePack = new LanguagePack();
                nwLanguagePack.setPropertiesFromObject(jsonObj.languagePack);
                this.languagePack.merge(nwLanguagePack);
            }

            jsonObj = jsonObj.dialog;
        }

        dialog = this.dialogParser.parseFromObject(jsonObj);
        if (!dialog) return null;

        this.dialogCache[dialogID] = dialog;

        return dialog;
    }
}

